import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appGalleryDragableImage]'
  })
export class GalleryImageDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }
}
